import {ResetTrialDataDialog} from "@/features/trial/resetTrialDataDialog";
import * as Button from "@/shared/utils/button";
import {formatDate, parseISODate} from "@/shared/utils/datefunctions";

export class AccountOnboardingWidget extends HTMLElement {

	public connectedCallback(): void {
		const trialUntil = this.getAttribute("data-trial-until");
		const trialUntilFormatted = messages.withArguments("onboardingDashboard.account.trialUntil", formatDate(parseISODate(trialUntil)));
		this.innerHTML = `
				<div class="panel panel-flat">
					<div class="panel-heading">
						<h4 class="panel-title">${messages["onboardingDashboard.account.becomeCustomer"]}</h4>
					</div>
					<div class="panel-body">
						<div class="flex-row">
							<div class="flex-column-auto" style="justify-content: space-between;"> 
								<p class="mb-10">${trialUntilFormatted}</p>
								<button class="btn btn-default" data-trial-data-reset="" style="width: fit-content;">${messages["admin.clientSettings.delete.resetData"]}</button>
							</div>
							<div class="ml-40 flex-column-auto" style="justify-content: space-between;">
								<div class="mb-10" style="font-size: 15px;">${messages["onboardingDashboard.account.readyToBuy"]}</div>
								<div class="text-grey mb-10"><i class="fal fa-info-circle position-left"></i>${messages["onboardingDashboard.account.readyToBuy.info"]}</div>
								<a class="btn btn-primary mt-5" href="/timr/account/account.html" style="width: fit-content;">${messages["onboardingDashboard.account.buyNow"]}</a>
							</div>
						</div>
					</div>
				</div>`;

		this.initEventListeners();
	}

	private initEventListeners() {
		this.querySelector("[data-trial-data-reset]").addEventListener("click", (e) => {
			const button = e.target as HTMLButtonElement;
			Button.setLoading(button);
			void ResetTrialDataDialog.show()
				.always(() => Button.resetLoading(button));
		});
	}
}
